import { useEffect } from 'react';
import { installVisualViewportBinding, isIosDevice, isStandalonePwa, markStandaloneDocument } from '@/lib/pwa';

/** Mark document when running as installed PWA and register service worker in production. */
export function usePwaBootstrap(): void {
  useEffect(() => {
    markStandaloneDocument();

    if (isStandalonePwa() && isIosDevice()) {
      return installVisualViewportBinding();
    }
  }, []);

  useEffect(() => {
    if (!import.meta.env.PROD) return;

    void import('virtual:pwa-register').then(({ registerSW }) => {
      registerSW({ immediate: true });
    });
  }, []);
}
